module.exports = __webpack_public_path__ + "static/media/nothing-to-show.80281548.png";